import React from "react";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import line from "../Assets/Rectangle 40191.svg";
import gift from "../Assets/image 165.svg";
import video from "../Assets/image 82.svg";
import arrow from "../Assets/Back.svg";

function PrintingProducts() {
  return (
    <div className="homepage">
      <Navbar />
      <br />
      <div className="festival-section">
        <div className="festival">
          <h3>
            <span>Home ></span> Visiting Card{" "}
          </h3>
          <br />
          <h1>Visiting Card</h1>
        </div>
      </div>
      <br /> <br />
      <div className="trendingOffer-section-heading">
        <img alt="" src={line} />
        <h1>Shop By Shapes</h1>
      </div>
      <br />
      <br />
      <div className="festival-gift-section">
        <div className="festival-gift"></div>
        <div className="giftproducts-section">
          <div className="giftproducts">
            <div className="giftproducts-card">
              <img alt="" src={gift} />
              <h2>Classic</h2>
            </div>
            <div className="giftproducts-card">
              <img alt="" src={gift} />
              <h2>Classic</h2>
            </div>
            <div className="giftproducts-card">
              <img alt="" src={gift} />
              <h2>Classic</h2>
            </div>
            <div className="giftproducts-card">
              <img alt="" src={gift} />
              <h2>Classic</h2>
            </div>
            <div className="giftproducts-card">
              <img alt="" src={gift} />
              <h2>Classic</h2>
            </div>
          </div>
        </div>
      </div>
      <br />
      <div className="flex justify-center items-center">
        <button className="abcd">
          Login to View Price <img alt="" className="logarrow" src={arrow} />
        </button>
      </div>
      <br />
      <br />
      <div className="video-section">
        <div className="video">
          <div className="trendingOffer-section-heading">
            <img alt="" src={line} />
            <h1>A Step By Step Guide To Make Your Digital Plan</h1>
          </div>
          <br />
          <br />

          <img alt="" className="vdio" src={video} />
        </div>
      </div>
      <br />
      <Footer />
    </div>
  );
}

export default PrintingProducts;
